import React from "react";
import "./Explore_Btn.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const Explore_Btn = ({ text = "Explore Program", onClick, className = "" }) => {
  return (
    <button className={`btn_explore_animated ${className}`} onClick={onClick}>
      <FontAwesomeIcon
        icon={faArrowRight}
        style={{ color: "#fff", fontSize:"18px" }}
        className="icon-entrance"
      />
      <span className="btn_text">{text}</span>

      <FontAwesomeIcon
        icon={faArrowRight}
        style={{ color: "#fff" , fontSize:"18px" }}
        className="icon-exit"
      />
    </button>
  );
};

export default Explore_Btn;
